import React from "react"
import { TestimonialCarousel } from "./testimonial-carousel"
import { Testimonial } from "../../lib/testimonials"

interface CarouselSectionProps {
  testimonials: Testimonial[]
}

export function CarouselSection({ testimonials }: CarouselSectionProps) {
  if (testimonials.length === 0) return null
  
  return (
    <div className="mt-16">
      <h3 className="text-2xl font-semibold mb-8 text-center">More Client Stories</h3>
      <TestimonialCarousel 
        testimonials={testimonials} 
        className="max-w-3xl mx-auto"
      />
    </div>
  )
} 